module.exports = __webpack_public_path__ + "static/08-490b182102a52e2595d6905b5e830e42.jpg";